<template>
  <MeetingModule v-if="shouldShow">
    <c-radio-group
      class="tw-gap-2"
      :options="radioOptions"
      v-model="model.allow_student_ratings"
    />
  </MeetingModule>
</template>

<script setup>
import { onMounted, ref, watchEffect, computed } from "vue";
import MeetingModule from "components/meeting/modules/MeetingModule.vue";

// Define the model
const model = defineModel({
  required: true,
  type: Object,
});
const isStepCompleted = defineModel("isStepCompleted");

// Refs
const radioOptions = ref([
  {
    label: "Inschakelen",
    value: 1,
  },
  {
    label: "Uitschakelen",
    value: 0,
  },
]);

// Computed
const shouldShow = computed(() => {
  // Only show this component when share feedback is enabled
  return model.value.mail_student;
});

// On model update
const modelUpdate = (value) => {
  isStepCompleted.value = model.value.mail_student === 0 || value != null;
};

onMounted(async () => {
  modelUpdate(model.value.allow_student_ratings);
});

watchEffect(() => {
  modelUpdate(model.value.allow_student_ratings);
});
</script>
